import { useState } from "react";
import { Input, Form, Modal, Typography, Tag, InputNumber, Space } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";

import { createItem, updateItem } from "@/api/taskTypes";
import { TASK_TYPE_OPTIONS } from "@/constants/tasks";

const { Text } = Typography;

// Окно для создания/редактирования типа задачи, содержит форму
const TaskTypeModal = ({ data = {}, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getIcon = (color) => {
    return TASK_TYPE_OPTIONS.find((item) => item.value === color)?.icon;
  };

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      if (data.uuid) {
        await updateItem({ ...data, ...values });
      } else {
        await createItem(values);
      }

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title={
        data.uuid
          ? "Редактирование типа задачи"
          : "Добавление нового типа задачи"
      }
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText={data.uuid ? "Сохранить" : "Добавить"}
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        <Form.Item
          name="name"
          label="Название"
          rules={[{ required: true, message: "Пожалуйста, введите название" }]}
        >
          <Input />
        </Form.Item>

        <Space>
          <Form.Item name="idx" label="Номер по порядку">
            <InputNumber />
          </Form.Item>

          <Form.Item name="style_key" label="Внешний вид">
            <CustomSelect
              options={TASK_TYPE_OPTIONS}
              optionRender={(option) => (
                <Tag icon={option?.data?.icon} className="tag-with-icon lg">
                  тип задачи
                </Tag>
              )}
              optionFilterProp="value"
              labelRender={(option) => (
                <Tag icon={getIcon(option.value)} className="tag-with-icon lg">
                  тип задачи
                </Tag>
              )}
              style={{ width: 145 }}
            />
          </Form.Item>
        </Space>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default TaskTypeModal;
